import { gql } from "@apollo/client";

export const GET_BLACK_LISTS = gql`
  query {
    blackList {
      id
      phone
      user_id
      type(asText: true)
      locked_at
      comment
      status
      created_at
    }
  }
`;

export const GET_BLACK_LIST = gql`
  query ($id: Int!, $lang: String!) {
    blackList(id: $id) {
      id
      phone
      user_id
      type
      locked_at
      comment
      user_id
    }
    list(method: "BlackList::listType", lang: $lang) {
      id
      name
    }
  }
`;

export const GET_BLACK_LISTS_HISTORY = gql`
  query ($phone: String!) {
    blackListHistory(phone: $phone) {
      id
      type(asText: true)
      locked_at
      comment
      created_at
      action
      files
    }
  }
`;
